'use strict';

angular.module('internal.trainings')
    .controller('InternalTrainingNotes', ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.resetTraining();

        $scope.link = {
            state: 'internal.licensing.training.note',
            params: [
                {
                    name: 'trainingNoteID',
                    field: 'id'
                },
                {
                    name: 'training_note',
                    field: ''
                }
            ]
        }

        $scope.columns = [
            {
                label: 'Note',
                field: 'note_display',
                type: 'ckeditor'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];

        $scope.filters = [
            {
                name: 'Date',
                field: 'createdon',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]
    }])
;